
export const GetShowcasePath = () => process.env.SHOWCASE_URL || "https://nuvee.fr";